/* Belle's theme behavior: cart drawer, ajax add, quantity, bundle builder, mobile nav. */
(function(){
  var money = function(cents){
    var s = (cents/100).toFixed(2);
    return (window.BellesTheme && window.BellesTheme.currencySymbol || '$') + s;
  };
  var cfg = window.BellesTheme || {};
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.className='toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-burger]');
    if(b){ var m = $('[data-mnav]'); if(m) m.classList.toggle('is-open'); }
  });

  /* ---------- cart drawer ---------- */
  /* The drawer is a modal dialog: focus moves in, Tab is trapped inside it, and on
     close focus returns to whatever opened it. */
  var lastFocus = null;
  function focusables(d){
    return $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', d)
      .filter(function(el){ return el.offsetParent !== null; });
  }
  function openDrawer(){
    var d=$('[data-drawer]'), s=$('[data-scrim]');
    lastFocus = document.activeElement;
    if(d){ d.classList.add('is-open'); }
    if(s){ s.classList.add('is-open'); }
    document.documentElement.style.overflow = 'hidden';
    if(d){ var f = focusables(d)[0]; if(f) f.focus(); }
  }
  function closeDrawer(){
    var d=$('[data-drawer]'), s=$('[data-scrim]');
    if(d){ d.classList.remove('is-open'); }
    if(s){ s.classList.remove('is-open'); }
    document.documentElement.style.overflow = '';
    if(lastFocus && lastFocus.focus){ lastFocus.focus(); lastFocus = null; }
  }
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Tab') return;
    var d = $('[data-drawer]');
    if(!d || !d.classList.contains('is-open')) return;
    var f = focusables(d);
    if(!f.length) return;
    var first = f[0], last = f[f.length-1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){
      e.preventDefault(); openDrawer(); renderDrawer();
    }
    if(e.target.closest('[data-cart-close]') || e.target.hasAttribute('data-scrim')) closeDrawer();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

  /* ---------- cart state ---------- */
  function getCart(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  function shipHtml(total){
    var th = (cfg.freeShipThreshold||0)*100;
    if(!th) return '';
    var hit = total >= th;
    var pct = Math.min(100, Math.round(total/th*100));
    var msg = hit ? (cfg.freeShipUnlocked||'Free shipping unlocked')
      : (money(th-total) + ' ' + (cfg.freeShipAway||'away from free shipping'));
    return '<div class="shipbar'+(hit?' is-hit':'')+'">'+
      '<div class="label" style="margin:0;color:var(--ink-700)">'+msg+'</div>'+
      '<div class="track"><i style="width:'+pct+'%"></i></div></div>';
  }

  /* ---------- drawer recommendations ----------
     Shopify's own recommendation engine, not a hand-built rule engine. Anything
     already in the cart and anything sold out is filtered out client-side, and the
     panel simply doesn't render when there is nothing worth suggesting. Nothing is
     ever added automatically. */
  var recCache = {};
  function renderRecs(cart){
    var wrap = $('[data-drawer-recs]');
    if(!wrap) return;
    if(!cart.items.length){ wrap.innerHTML = ''; return; }
    var seed = cart.items[cart.items.length-1].product_id;
    var inCart = cart.items.map(function(i){ return i.product_id; });
    function paint(list){
      var picks = list.filter(function(p){
        return p.available && inCart.indexOf(p.id) === -1;
      }).slice(0, 3);
      if(!picks.length){ wrap.innerHTML = ''; return; }
      wrap.innerHTML = '<div class="recs">'+
        '<span class="label" style="margin:0 0 10px">'+(cfg.recsTitle||'Complete your family')+'</span>'+
        picks.map(function(p){
          var img = p.featured_image ? '<img src="'+p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2')+'" alt="">' : '';
          return '<div class="rec">'+
            '<div class="rec__img">'+img+'</div>'+
            '<div class="rec__txt"><span class="rec__name">'+p.title+'</span>'+
              '<span class="rec__price">'+money(p.price)+'</span></div>'+
            '<button type="button" class="rec__add" data-rec-add="'+p.variants[0].id+'" '+
              'aria-label="Add '+p.title.replace(/"/g,'&quot;')+' to cart">+</button>'+
          '</div>';
        }).join('')+'</div>';
    }
    if(recCache[seed]){ paint(recCache[seed]); return; }
    fetch('/recommendations/products.json?product_id='+seed+'&limit=6&intent=complementary')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var list = (d && d.products) || [];
        if(!list.length){
          return fetch('/recommendations/products.json?product_id='+seed+'&limit=6&intent=related')
            .then(function(r){ return r.json(); })
            .then(function(d2){ return (d2 && d2.products) || []; });
        }
        return list;
      })
      .then(function(list){ recCache[seed] = list; paint(list); })
      .catch(function(){ wrap.innerHTML = ''; });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-rec-add]');
    if(!b) return;
    b.disabled = true;
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(b.getAttribute('data-rec-add')), quantity: 1 }] })
    }).then(function(r){ return r.json(); })
      .then(function(){ renderDrawer(); })
      .catch(function(){ b.disabled = false; toast('Could not add that one'); });
  });

  function renderDrawer(){
    var body = $('[data-drawer-body]'), ft = $('[data-drawer-total]'), ship = $('[data-drawer-ship]');
    if(!body) return;
    getCart().then(function(cart){
      updateCount(cart.item_count);
      if(ship) ship.innerHTML = shipHtml(cart.total_price);
      renderRecs(cart);
      if(!cart.items.length){
        body.innerHTML = '<div style="text-align:center;padding:40px 0"><div class="hand">'+(cfg.emptyCart||'Your bag is empty!')+'</div></div>';
        if(ft) ft.textContent = money(0);
        return;
      }
      var boxes = {}, boxOrder = [], loose = [];
      cart.items.forEach(function(it){
        var bid = it.properties && it.properties._box;
        if(bid){
          if(!boxes[bid]){ boxes[bid] = []; boxOrder.push(bid); }
          boxes[bid].push(it);
        } else loose.push(it);
      });
      var boxHtml = boxOrder.map(function(bid){
        var lines = boxes[bid], n = 0, orig = 0, fin = 0;
        lines.forEach(function(it){ n += it.quantity; orig += it.original_line_price; fin += it.final_line_price; });
        var thumbs = lines.slice(0,4).map(function(it){
          return it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_80x$1$2')+'" alt="">' : '';
        }).join('');
        var list = lines.map(function(it){ return it.product_title + (it.quantity > 1 ? ' &times;' + it.quantity : ''); }).join(', ');
        return '<div class="dline dline--box" data-box="'+bid+'">'+
          '<div class="dline__img dline__img--box">'+thumbs+'</div>'+
          '<div style="flex:1;min-width:0">'+
            '<div class="dline__name">'+(cfg.boxTitle||'Build a Box')+' &middot; '+n+' bags</div>'+
            '<div class="muted" style="font-size:var(--text-xs);line-height:1.35;margin-top:2px">'+list+'</div>'+
          '</div>'+
          '<div style="text-align:right;flex:none">'+
            (fin < orig ? '<div class="muted" style="font-size:var(--text-xs);text-decoration:line-through">'+money(orig)+'</div>' : '')+
            '<div style="font-family:var(--font-heading);font-weight:700;font-size:var(--text-sm)">'+money(fin)+'</div>'+
            '<button type="button" class="lnk" data-box-remove="'+bid+'">'+(cfg.remove||'Remove')+'</button>'+
          '</div>'+
        '</div>';
      }).join('');
      body.innerHTML = boxHtml + loose.map(function(it){
        var img = it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2')+'" alt="">' : '';
        var sub = it.selling_plan_allocation ? ' &middot; '+it.selling_plan_allocation.selling_plan.name : '';
        var opts = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        return '<div class="dline" data-key="'+it.key+'">'+
          '<div class="dline__img">'+img+'</div>'+
          '<div style="flex:1;min-width:0">'+
            '<div class="dline__name">'+it.product_title+'</div>'+
            '<div class="muted" style="font-size:var(--text-xs)">'+opts+sub+'</div>'+
            '<div class="qty" style="border-width:2px;margin-top:5px">'+
              '<button type="button" data-dq="-1" aria-label="Decrease">&minus;</button>'+
              '<input type="text" value="'+it.quantity+'" data-dqty readonly style="width:32px">'+
              '<button type="button" data-dq="1" aria-label="Increase">+</button>'+
            '</div>'+
          '</div>'+
          '<div style="text-align:right;flex:none">'+
            (it.final_line_price < it.original_line_price ? '<div class="muted" style="font-size:var(--text-xs);text-decoration:line-through">'+money(it.original_line_price)+'</div>' : '')+
            '<div style="font-family:var(--font-heading);font-weight:700;font-size:var(--text-sm)">'+money(it.final_line_price)+'</div>'+
            '<button type="button" class="lnk" data-dremove>'+(cfg.remove||'Remove')+'</button>'+
          '</div>'+
        '</div>';
      }).join('') + (cart.total_discount > 0
        ? '<div class="sumrow" style="color:var(--birthday-pink-dark);margin-top:10px"><span>'+(cfg.boxSaved||'Box discount')+'</span><span>&minus;'+money(cart.total_discount)+'</span></div>'
        : '');
      if(ft) ft.textContent = money(cart.total_price);
    });
  }

  function updateCount(n){
    $$('[data-cart-count]').forEach(function(el){ el.textContent = n; });
  }

  function change(key, qty){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();});
  }

  /* Remove a whole box: zero every line carrying its _box id in one update. */
  document.addEventListener('click', function(e){
    var rb = e.target.closest('[data-box-remove]');
    if(!rb) return;
    var bid = rb.getAttribute('data-box-remove');
    rb.disabled = true;
    getCart().then(function(cart){
      var updates = {};
      cart.items.forEach(function(it){ if(it.properties && it.properties._box === bid) updates[it.key] = 0; });
      return fetch('/cart/update.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ updates: updates })
      });
    }).then(function(){ renderDrawer(); if($('[data-cart-page]')) window.location.reload(); });
  });

  document.addEventListener('click', function(e){
    var line = e.target.closest('[data-key]');
    if(!line) return;
    var key = line.getAttribute('data-key');
    var dq = e.target.closest('[data-dq]');
    if(dq){
      var input = $('[data-dqty]', line);
      var next = parseInt(input.value,10) + parseInt(dq.getAttribute('data-dq'),10);
      change(key, Math.max(0,next)).then(function(){ renderDrawer(); if($('[data-cart-page]')) window.location.reload(); });
    }
    if(e.target.closest('[data-dremove]')){
      change(key, 0).then(function(){ renderDrawer(); if($('[data-cart-page]')) window.location.reload(); });
    }
  });

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-add]');
    if(!form) return;
    if(e.submitter && e.submitter.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    var buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
    var btn = e.submitter && e.submitter.type === 'submit' ? e.submitter : form.querySelector('[type=submit]');
    if(btn){ btn.disabled = true; }
    var fd = new FormData(form);
    fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description||j.message||'Sold out'); return j; }); })
      .then(function(){
        if(btn) btn.disabled = false;
        if(buyNow){ window.location.href = '/checkout'; return; }
        openDrawer(); renderDrawer();
      })
      .catch(function(err){ if(btn) btn.disabled=false; toast(err.message); });
  });

  /* ---------- pdp quantity ---------- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-q]');
    if(!q) return;
    var input = q.parentElement.querySelector('input[name=quantity]');
    if(!input) return;
    var v = parseInt(input.value,10) + parseInt(q.getAttribute('data-q'),10);
    input.value = Math.max(1, v);
  });

  /* ---------- pdp variant picker ---------- */
  $$('[data-variants]').forEach(function(root){
    var data = JSON.parse(root.getAttribute('data-variants'));
    var idInput = root.querySelector('input[name=id]');
    var priceEl = root.querySelector('[data-price]');
    var subEl = root.querySelector('[data-subprice]');
    var addBtn = root.querySelector('[data-add-label]');
    var sPrice = $('[data-satc-price]'), sPack = $('[data-satc-pack]'),
        sLabel = $('[data-satc-label]'), sBtn = $('[data-satc-add]');
    var gallery = root.querySelector('[data-gallery]');
    function syncGallery(variant){
      if(!gallery || !variant) return;
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = $$('[data-thumb]', gallery);
      if(!thumbs.some(function(thumb){ return thumb.getAttribute('data-gallery-packs'); })) return;
      var packThumb;
      thumbs.forEach(function(thumb){
        var packs = (thumb.getAttribute('data-gallery-packs') || '').split(' ').filter(Boolean);
        thumb.hidden = packs.length > 0 && packs.indexOf(variant.pack) === -1;
        if(packs.length && !thumb.hidden && !packThumb) packThumb = thumb;
      });
      var target = packThumb || thumbs.filter(function(thumb){ return !thumb.hidden; })[0];
      if(main && target){
        main.src = target.getAttribute('data-thumb');
        main.alt = target.getAttribute('data-gallery-alt') || '';
        thumbs.forEach(function(thumb){ thumb.setAttribute('aria-current', String(thumb === target)); });
      }
    }
    syncGallery(data.filter(function(variant){ return variant.id === Number(idInput.value); })[0]);
    function pick(id){
      var v = data.filter(function(x){ return x.id === id; })[0];
      if(!v) return;
      idInput.value = v.id;
      syncGallery(v);
      $$('[data-opt]', root).forEach(function(b){ b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-opt'))===id)); });
      if(priceEl) priceEl.innerHTML = money(v.price) + (v.compare > v.price ? ' <s>'+money(v.compare)+'</s>' : '');
      if(subEl && cfg.subPct) subEl.textContent = money(Math.round(v.price*(1-cfg.subPct/100)));
      if(addBtn) addBtn.textContent = v.available ? (cfg.addToCart||'Add to cart') : (cfg.soldOut||'Sold out');
      var submit = root.querySelector('[type=submit]');
      if(submit) submit.disabled = !v.available;
      /* keep the sticky bar honest about the selected pack, price and availability */
      if(sPrice) sPrice.textContent = money(v.price);
      if(sPack && data.length > 1) sPack.textContent = v.title || '';
      if(sLabel) sLabel.textContent = v.available ? 'Add to bag' : (cfg.soldOut||'Sold out');
      if(sBtn) sBtn.disabled = !v.available;
      if(history.replaceState) history.replaceState({}, '', '?variant='+v.id);
    }
    $$('[data-opt]', root).forEach(function(b){
      b.addEventListener('click', function(){ pick(Number(b.getAttribute('data-opt'))); });
    });
    var plans = $$('input[name=selling_plan]', root);
    plans.forEach(function(p){
      p.addEventListener('change', function(){
        $$('[data-plan]', root).forEach(function(l){ l.classList.toggle('plan--on', l.contains(p) && p.checked); });
      });
    });
  });

  /* ---------- pdp gallery ---------- */
  $$('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gallery-main]');
    $$('[data-thumb]', g).forEach(function(t){
      t.addEventListener('click', function(){
        if(t.hidden) return;
        main.src = t.getAttribute('data-thumb');
        main.alt = t.getAttribute('data-gallery-alt') || '';
        $$('[data-thumb]', g).forEach(function(x){ x.setAttribute('aria-current', String(x===t)); });
      });
    });
  });

  /* ---------- box discount ----------
     A theme can't grant a discount by itself — Shopify only prices what it
     knows about. So once a box is in the cart we attach the box code to the
     cart (Cart API "discount" field), and fall back to Shopify's own
     /discount/CODE link, which sets the same code on the session. Either way
     Shopify still checks the minimum-quantity rule, so the code only bites
     when there really are enough bags. */
  function applyBoxCode(){
    var code = (cfg.bundleCode || '').trim();
    if(!code) return Promise.resolve();
    return getCart().then(function(cart){
      var have = (cart.discount_codes || []).map(function(d){ return String(d.code).toUpperCase(); });
      if(have.indexOf(code.toUpperCase()) > -1) return;
      var keep = (cart.discount_codes || []).filter(function(d){ return d.applicable; }).map(function(d){ return d.code; });
      keep.push(code);
      return fetch('/cart/update.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ discount: keep.join(',') })
      }).then(function(r){
          if(!r.ok) throw new Error('update');
          return r.json().then(function(c){
            /* Diagnostic for the store owner: Shopify accepted the request but the
               code doesn't exist, or its rules (min qty, products) don't match. */
            var hit = (c.discount_codes || []).filter(function(d){ return String(d.code).toUpperCase() === code.toUpperCase(); })[0];
            if(!hit || !hit.applicable) console.warn('[Belles] Box code "' + code + '" was not applied. Create it in Shopify admin > Discounts (Amount off products, 15%, minimum quantity ' + (cfg.bundleSize||8) + ', All products).');
          });
        })
        .catch(function(){
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials:'same-origin' });
        });
    }).catch(function(){});
  }

  /* ---------- discount code ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-discount-apply]');
    if(!b) return;
    var input = b.parentElement.querySelector('input');
    var code = (input && input.value || '').trim();
    if(!code){ toast(cfg.enterCode||'Enter a code'); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });

  /* ---------- bundle builder ---------- */
  var bundle = $('[data-bundle]');
  if(bundle){
    var size = parseInt(bundle.getAttribute('data-bundle-size'),10) || 6;
    var picks = [];
    var list = $('[data-bundle-list]', bundle);
    var countEl = $('[data-bundle-count]', bundle);
    var barEl = $('[data-bundle-bar]', bundle);
    var grossEl = $('[data-bundle-gross]', bundle);
    var saveEl = $('[data-bundle-save]', bundle);
    var totalEl = $('[data-bundle-total]', bundle);
    var addBtn = $('[data-bundle-add]', bundle);
    var thumbsEl = $('[data-bundle-thumbs]', bundle);
    var pct = parseFloat(bundle.getAttribute('data-bundle-discount')) || 15;
    var msEl = $('[data-bundle-milestone]', bundle);

    /* Milestone copy is authored in the section settings; this only decides which
       line applies to the current count. */
    function milestone(n){
      if(!msEl) return;
      var d = msEl.dataset, left = size - n, txt;
      if(n === 0) txt = d.empty;
      else if(n >= size) txt = d.full;
      else if(left === 2 && d.near) txt = d.near;
      else if(n * 2 === size && d.half) txt = d.half;
      else txt = (d.more || '[n] more to go.').replace('[n]', left);
      msEl.textContent = txt || '';
    }

    function cards(){
      return $$('[data-bundle-card]', bundle).filter(function(c){
        return !c.classList.contains('bcard--out');
      });
    }

    function addCard(card){
      if(picks.length >= size) return false;
      picks.push({
        id: Number(card.getAttribute('data-bundle-card')),
        title: card.getAttribute('data-bundle-title'),
        price: Number(card.getAttribute('data-bundle-price')),
        img: card.getAttribute('data-bundle-img')
      });
      return true;
    }

    function draw(){
      var gross = picks.reduce(function(s,p){ return s + p.price; }, 0);
      countEl.textContent = picks.length + ' / ' + size;
      barEl.style.width = Math.round(picks.length/size*100) + '%';
      grossEl.textContent = money(gross);
      saveEl.textContent = '-' + money(Math.round(gross*pct/100));
      totalEl.textContent = money(Math.round(gross*(1-pct/100)));
      addBtn.disabled = picks.length !== size;
      list.innerHTML = picks.map(function(p,i){
        return '<div class="sumrow"><span>'+p.title+'</span><button type="button" class="lnk" data-bundle-remove="'+i+'">&times;</button></div>';
      }).join('');
      if(thumbsEl){
        var slots = '';
        for(var i=0;i<size;i++){
          var p = picks[i];
          if(p){
            slots += '<button type="button" class="boxbag" data-bundle-remove="'+i+'" title="Remove '+p.title+'" aria-label="Remove '+p.title+'">'+
              (p.img ? '<img src="'+p.img+'" alt="'+p.title+'">' : '<span class="boxbag__ini">'+p.title.charAt(0)+'</span>')+'</button>';
          } else {
            slots += '<span class="boxbag boxbag--empty" aria-hidden="true"></span>';
          }
        }
        thumbsEl.innerHTML = slots;
      }
      $$('[data-bundle-card]', bundle).forEach(function(c){
        var id = Number(c.getAttribute('data-bundle-card'));
        var n = picks.filter(function(p){ return p.id===id; }).length;
        c.classList.toggle('is-on', n>0);
        var mark = $('[data-bundle-mark]', c);
        if(mark) mark.textContent = n ? 'x'+n : '+';
      });
      milestone(picks.length);
    }
    bundle.addEventListener('click', function(e){
      /* The minus button lives inside the card, so it has to win before the
         card's own add-handler runs — otherwise the two cancel out. */
      var less = e.target.closest('[data-bundle-less]');
      if(less){
        e.preventDefault();
        e.stopPropagation();
        /* take out the LAST one of this flavor, so repeated clicks unwind cleanly */
        var lid = Number(less.getAttribute('data-bundle-less'));
        for(var li = picks.length - 1; li >= 0; li--){
          if(picks[li].id === lid){ picks.splice(li,1); break; }
        }
        draw();
        return;
      }
      var card = e.target.closest('[data-bundle-card]');
      if(card && !card.classList.contains('bcard--out')){
        if(picks.length >= size){ toast(cfg.boxFull||'Box is full'); return; }
        addCard(card);
        draw();
      }
      if(e.target.closest('[data-bundle-surprise]')){
        /* Fill from best-sellers first, then anything else available. Never a
           sold-out flavor, and the result stays fully editable. */
        var pool = cards();
        var stars = pool.filter(function(c){ return c.hasAttribute('data-bundle-star'); });
        var rest = pool.filter(function(c){ return !c.hasAttribute('data-bundle-star'); });
        function shuffle(a){
          for(var i=a.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=a[i]; a[i]=a[j]; a[j]=t; }
          return a;
        }
        var order = shuffle(stars.slice()).concat(shuffle(rest.slice()));
        picks = [];
        for(var oi=0; oi<order.length && picks.length<size; oi++){ addCard(order[oi]); }
        /* fewer distinct flavors than the box holds: double up rather than short-fill */
        var guard = 0;
        while(picks.length < size && order.length && guard < size*4){
          addCard(order[guard % order.length]); guard++;
        }
        draw();
        toast(cfg.boxFilled || 'Box filled — swap anything you like');
        return;
      }
      var rm = e.target.closest('[data-bundle-remove]');
      if(rm){ picks.splice(Number(rm.getAttribute('data-bundle-remove')),1); draw(); }
      if(e.target.closest('[data-bundle-add]')){
        if(picks.length !== size) return;
        var items = {};
        picks.forEach(function(p){ items[p.id] = (items[p.id]||0) + 1; });
        /* Every bag in this box shares a hidden _box id, so the cart can show
           the box as one row. Underscore properties are hidden at checkout. */
        var boxId = 'B' + Date.now().toString(36).toUpperCase();
        var payload = Object.keys(items).map(function(id){
          return { id:Number(id), quantity:items[id], properties:{ _box: boxId, _box_size: String(size) } };
        });
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: payload, attributes: { 'Build a Box': size + ' bags' } })
        }).then(function(r){
          return r.json().then(function(res){
            if(!r.ok) throw new Error(res.description || res.message || 'Could not add the box');
            return res;
          });
        }).then(function(){
          return applyBoxCode();
        }).then(function(){
          picks = []; draw();
          openDrawer(); renderDrawer();
        }).catch(function(err){ toast(err && err.message ? err.message : 'Could not add the box'); });
      }
    });

    /* Quiz handoff. The quiz sends its recommendations as ?flavors=handle,handle,
       so the builder opens with those bags already in the box — still editable,
       still subject to the same availability rules (an unknown or sold-out handle
       is simply skipped). */
    (function prefill(){
      var q = new URLSearchParams(location.search).get('flavors');
      if(!q) return;
      var wanted = q.split(',').map(function(h){ return h.trim(); }).filter(Boolean);
      var pool = cards();
      wanted.forEach(function(h){
        if(picks.length >= size) return;
        var card = pool.filter(function(c){ return c.getAttribute('data-bundle-handle') === h; })[0];
        if(card) addCard(card);
      });
      if(picks.length){
        toast(cfg.boxPrefilled || 'Your flavors are in the box — add more or swap any');
      }
    })();

    draw();
  }

  getCart().then(function(c){ updateCount(c.item_count); }).catch(function(){});
})();


/* Page transitions ------------------------------------------------------- */
/* Chrome/Safari handle this in CSS via @view-transition. Everywhere else we
   fade the current page out before letting the browser navigate. */
(function () {
  var supported = 'startViewTransition' in document &&
    CSS.supports && CSS.supports('selector(::view-transition)');
  if (supported) return;
  var html = document.documentElement;
  html.classList.add('no-vt');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.hasAttribute('data-cart-open')) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.hash) return;
    if (!/^https?:$/.test(url.protocol)) return;
    e.preventDefault();
    html.classList.add('is-leaving');
    setTimeout(function () { location.href = a.href; }, 150);
  });

  // Coming back via the back button must not leave the page faded out.
  window.addEventListener('pageshow', function () { html.classList.remove('is-leaving'); });
})();


/* Predictive search ------------------------------------------------------- */
/* Shopify's /search/suggest.json gives products, pages and collections as you
   type. The panel is built in JS so both the header form and the mobile menu
   form get it without touching markup. Keyboard: up/down to move, enter to open,
   escape to close. */
(function () {
  var forms = document.querySelectorAll('form.srch');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    form.style.position = 'relative';
    var panel = document.createElement('div');
    panel.className = 'sugg';
    panel.setAttribute('role', 'listbox');
    form.appendChild(panel);

    var timer = null, active = -1, items = [];

    function close() { panel.classList.remove('is-open'); panel.innerHTML = ''; active = -1; items = []; }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function render(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var pages = (res.pages || []).concat(res.collections || []);
      if (!products.length && !pages.length) {
        panel.innerHTML = '<div class="sugg__none">No matches for &ldquo;' + q.replace(/[<>&]/g, '') + '&rdquo;</div>';
        panel.classList.add('is-open');
        items = [];
        return;
      }
      var html = '';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        html += '<a class="sugg__row" href="' + p.url + '">'
          + '<span class="sugg__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="sugg__txt"><span class="sugg__name">' + p.title + '</span>'
          + (p.price ? '<span class="sugg__price">' + money(Number(p.price)) + '</span>' : '')
          + '</span></a>';
      });
      pages.forEach(function (pg) {
        html += '<a class="sugg__row sugg__row--page" href="' + pg.url + '">'
          + '<span class="sugg__txt"><span class="sugg__name">' + pg.title + '</span></span></a>';
      });
      html += '<a class="sugg__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + q.replace(/[<>&]/g, '') + '&rdquo;</a>';
      panel.innerHTML = html;
      panel.classList.add('is-open');
      items = Array.prototype.slice.call(panel.querySelectorAll('a'));
      active = -1;
    }

    function lookup(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,page,collection&resources[limit]=6'
        + '&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, q); })
        .catch(function () { close(); });
    }

    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { lookup(q); }, 180);
    });

    input.addEventListener('keydown', function (e) {
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active += (e.key === 'ArrowDown' ? 1 : -1);
        if (active < 0) active = items.length - 1;
        if (active >= items.length) active = 0;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = items[active].href;
      } else if (e.key === 'Escape') {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  });
})();


/* Sticky mobile add-to-cart ------------------------------------------------ */
/* The bar owns no state — its button submits the real product form, so pack,
   selling plan and quantity all come from the form itself. It hides while the
   real add-to-cart row is on screen so it never duplicates a visible control. */
(function () {
  var bar = document.querySelector('[data-satc]');
  if (!bar) return;
  var form = document.querySelector('form[data-ajax-add]');
  var row = document.querySelector('[data-atc-row]');
  if (!form || !row) { bar.remove(); return; }

  bar.hidden = false;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-satc-add]')) return;
    /* requestSubmit fires the submit event, so the ajax handler picks it up */
    if (form.requestSubmit) form.requestSubmit();
    else form.querySelector('[type=submit]').click();
  });

  if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      bar.classList.toggle('is-on', !en.isIntersecting);
    });
  }, { rootMargin: '-70px 0px 0px 0px' }).observe(row);
})();


/* Funnel events ----------------------------------------------------------- */
/* Belle's-specific steps only. Shopify's pixel already reports view_item,
   add_to_cart, begin_checkout and purchase to GA4/Meta/TikTok, so re-emitting
   those here would double-count every conversion. Everything below is a step
   Shopify has no concept of. */
(function () {
  var cfg = window.BellesTheme || {};
  if (cfg.track === false) { window.BellesTrack = function () {}; return; }

  window.dataLayer = window.dataLayer || [];
  function track(name, data) {
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
  }
  window.BellesTrack = track;

  var boxStarted = false, quizStarted = false;

  document.addEventListener('click', function (e) {
    var t = e.target;

    var card = t.closest && t.closest('[data-bundle-card]');
    if (card && !card.classList.contains('bcard--out')) {
      if (!boxStarted) { boxStarted = true; track('build_box_start'); }
      track('build_box_add', {
        flavor: card.getAttribute('data-bundle-handle') || card.getAttribute('data-bundle-title')
      });
    }
    if (t.closest && t.closest('[data-bundle-surprise]')) {
      if (!boxStarted) { boxStarted = true; track('build_box_start'); }
      track('build_box_surprise');
    }
    if (t.closest && t.closest('[data-bundle-add]')) track('build_box_complete');

    if (t.closest && t.closest('[data-quick-add]')) track('quick_add');
    if (t.closest && t.closest('[data-rec-add]')) track('cart_recommendation_add');

    var opt = t.closest && t.closest('.quiz__opt');
    if (opt) {
      if (!quizStarted) { quizStarted = true; track('quiz_start'); }
      track('quiz_answer');
    }
    var chip = t.closest && t.closest('.chip--filter');
    if (chip) track('collection_filter', {
      filter: chip.textContent.trim(),
      action: chip.getAttribute('aria-pressed') === 'true' ? 'remove' : 'add'
    });

    var reelShop = t.closest && t.closest('.reel__shop');
    if (reelShop) track('reel_shop_click', { url: reelShop.getAttribute('href') });
  });

  /* The quiz result card only ever appears once per run, so observing it is a
     cleaner signal than trying to count answers. */
  if ('MutationObserver' in window) {
    var quizRoot = document.querySelector('[data-belles-quiz]');
    if (quizRoot) {
      new MutationObserver(function () {
        var res = quizRoot.querySelector('.quiz__result .pcard__flavor');
        if (res && !quizRoot.dataset.tracked) {
          quizRoot.dataset.tracked = '1';
          track('quiz_complete', { result: res.textContent.trim() });
        }
        if (!res) delete quizRoot.dataset.tracked;
      }).observe(quizRoot, { childList: true, subtree: true });
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('.notify__form')) track('notify_signup', { source: 'coming_soon' });
    else if (f.closest && f.closest('.notifybox')) track('notify_signup', { source: 'restock' });
    else if (f.querySelector && f.querySelector('input[name="contact[tags]"][value="newsletter"]')) {
      track('email_signup', { source: 'footer' });
    }
  });

  var loc = document.getElementById('loc-filter');
  if (loc) {
    var lt = null;
    loc.addEventListener('input', function () {
      clearTimeout(lt);
      lt = setTimeout(function () {
        if (loc.value.trim().length > 2) track('store_locator_search', { query: loc.value.trim() });
      }, 900);
    });
  }
})();
